module.exports = __webpack_public_path__ + "static/media/feature-entrepreneur.a6f26fcb.png";